import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().email('msg_error_invalid_email_format').required('msg_error_required_field'),
});
